export default __webpack_public_path__ + "static/media/buster_klein_58.63cc9cbe.jpg";